/**
 *Created by jmmartinez on 24/09/2020
 * 18/05/2023 v1.1 Añadidos los métodos transformarCadenaColores y getColorDeLista.
  * */

import React from 'react'
import {calcularDateFromCadena, getDateFromNowSinHora} from "../ej2/utils/DateUtils";
import {CELLTIPO_CADENA, CELLTIPO_COLOR, CELLTIPO_FECHA} from "../ej2/UI/TiposCeldas";




export const transformar= (tipo, valor) => {
    switch (tipo.toUpperCase()) {
            case CELLTIPO_COLOR: return transformadorColor(valor);
            case CELLTIPO_FECHA: return transformadorDate(valor);
            default:  return valor;
    }

}

//Desde la cadena "dd/mm/yyyy" devolvemos el timestamp
export const transformadorDate= (cadenaFecha) => {
    if (cadenaFecha=== ""){

    }
    else{
        let dateNewFecha= calcularDateFromCadena(cadenaFecha);
        let timeNewFecha= 0;
        if (dateNewFecha != null)
            timeNewFecha= dateNewFecha.getTime();
        else
            timeNewFecha= getDateFromNowSinHora().getTime();
        return timeNewFecha;
    }
}

//Desde la cadena "rrggbb" devolvemos "#rrggbb"
export const transformadorColor= (cadenaColor) => {
    //console.log("transformadorColor:");
    //console.log("cadenaColor: ", cadenaColor);
    if (cadenaColor && cadenaColor!== ""){
        let cadenaColorNew= cadenaColor.trim();
        if (cadenaColorNew.charAt(0) != '#')
            cadenaColorNew= "#" + cadenaColorNew;
        return cadenaColorNew;
    }
}

export const transformarCadenaColores= (cadenaOriginal, listaColores, separador) => {
    //console.log("transformarCadenaColores: ");
    //console.log("cadenaOriginal: ", cadenaOriginal);
    let arrayComponentes=[];
    if (!cadenaOriginal){
        arrayComponentes.push(<span style={{marginLeft: 4, color:'#000000'}}></span>);
    }
    else {
        let separadorReal= separador ? separador : ",";
        let partes= cadenaOriginal.split(separadorReal);
        partes.forEach( (parte, index) => {
            let parteTrim= parte.trim();
            //console.log("parteTRim: ", parteTrim);
            let prefijo= parteTrim.charAt(0);
            let sufijo= parteTrim.slice(-1);
            let colores= getColoresDeLista(listaColores, prefijo, sufijo);
            if (colores != null){
                let cadenaMostrar= parteTrim.slice(1,-1);
                arrayComponentes.push(<span style={{backgroundColor: colores.color, marginLeft: 4, color:colores.colorFont }}>{cadenaMostrar}</span>);
            }
            else{
                arrayComponentes.push(<span style={{marginLeft: 4, color:'#000000'}}>{parteTrim}</span>);
            }
        });
    }
    return arrayComponentes;
}

const getColoresDeLista= (listaColores, prefijo, sufijo) => {
    let colores= null;
    if (listaColores) {
        listaColores.forEach((elemento) => {
            if (elemento.prefijo == prefijo && elemento.sufijo == sufijo)
                colores = {color: elemento.color, colorFont: elemento.colorFont}
        });
    }
    return colores;
}